import React, { useEffect, useState, useRef } from 'react';
import Select from 'react-select';
import { FaMinus } from "react-icons/fa6";
import { IoMdAdd } from "react-icons/io";
import { AxiosInstance } from '../../common/Loader/axios.config';
import Swal from 'sweetalert2';
import LinearProgress from '@mui/material/LinearProgress/LinearProgress';


const UploadVOD: React.FC = ({ videoFile, setUploadStatus, setProgress, ref }) => {

    const [thumbnail, setThumbnail] = useState<File | null>(null);
    const [uploading, setUploading] = useState(false);
    const [price, setPrice] = useState(0);
    const [title, setTitle] = useState('');
    const [type, setType] = useState('');
    const [city, setCity] = useState('');
    const [projectName, setProjectName] = useState('');
    const [description, setDescription] = useState('');
    const [category, setCategory] = useState('');
    const [region, setRegion] = useState('');
    const [trailer, setTrailer] = useState('');
    const [providers, setProviders] = useState([]);
    const [selectedProvider, setSelectedProvider] = useState(null);
    const [video_provider, setVideoProvider] = useState('');
    const [startDate, setStartDate] = useState('');
    const [seriesOption, setSeriesOption] = useState('');
    const [content, setContent] = useState([]);
    const [selectedSeries, setSelectedSeries] = useState(null);

    useEffect(() => {
        AxiosInstance.get("/new-content")
          .then((response) => {
            const allContent = response.data.message;
    
            // Filter content based on type
            const filteredContent = allContent.filter((content) =>
              ["vod"].includes(content.category)
            );
    
            const sortedContent = filteredContent.sort((a, b) => {
              return (
                new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
              );
            });
    
            setContent(sortedContent);
          })
          .catch((error) => {
            console.error("Error fetching content:", error);
          });
      }, []);

      const seriesOptions = content.map((content) => ({
        value: content.id,
        label: content.title,
    }));

    const handleSeriesChange = (option) => {
        setSelectedSeries(option);
        console.log("Selected Series", option);
    };

    useEffect(() => {
        AxiosInstance.get("/content-providers")
            .then((response) => {
                const allProviders = response.data;

                console.log("All Providers", allProviders);

                const sortedProviders = allProviders.sort((a, b) => {
                    return (
                        new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
                    );
                });

                setProviders(sortedProviders)
            })
            .catch((error) => {
            });
    }, []);

    const providerOptions = providers.map((provider) => ({
        value: provider.id,
        label: provider.name,
    }));

    const handleProviderChange = (option) => {
        setSelectedProvider(option);
        setVideoProvider(option.value);
    };

    const decreasePrice = () => {
        setPrice(price - 10);
    };

    const increasePrice = () => {
        setPrice(price + 10);
    };

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const selectedFile = event.target.files?.[0];

        if (selectedFile && title) {
            const fileExtension = selectedFile.name.split('.').pop();
            const newFileName = `${title}.${fileExtension}`;
            const renamedFile = new File([selectedFile], newFileName, {
                type: selectedFile.type,
            });

            setThumbnail(renamedFile);
        }
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        setUploadStatus("inProgress");

        const formData = new FormData();

        formData.append("title", title);
        formData.append("description", description);
        formData.append("category", "vod");

        formData.append("provider", video_provider);
        formData.append("project_name", projectName);
        formData.append("price", price);


        if (startDate) {
            formData.append("start_time", startDate);
        }

        if (videoFile) {
            formData.append("video", videoFile);
        }

        if (thumbnail) {
            formData.append("thumbnail", thumbnail);
        }

        if (trailer) {
            formData.append("trailer", trailer);
        }

        for (const [key, value] of formData.entries()) {
            if (value instanceof File) {
                console.log(`${key}:`, value.name, value.size, value.type);
            } else {
                console.log(`${key}: ${value}`);
            }
        }

        // try {
        //     const response = await AxiosInstance.post("/new-content", formData, {
        //         headers: {
        //             "Content-Type": "multipart/form-data",
        //         },
        //     });

        //     console.log("Upload Response", response);

        //     if (response.status === 201) {
        //         if (response.data.status === "succesful") {
        //             console.log("Upload successful:", response.data.message);
        //             ContentVideoUpload(response.data.message);
        //         } else {
        //             setUploadStatus("failure");
        //             console.error("Upload failed:", response.data.message);
        //         }
        //     } else {
        //         setUploadStatus("failure");
        //         console.error("Upload failed with status:", response.status);
        //     }
        // } catch (error) {
        //     console.error("Error uploading data:", error);
        // }
    };

    const ContentVideoUpload = async (parent) => {
        const childData = new FormData();
        childData.append('parent_content', parent._id);
        childData.append('title', parent.title);
        childData.append('description', parent.description);
        childData.append('price', parent.price);

        childData.append('package_name', "KanemaFlex");
        childData.append('category', "vod");

        for (const [key, value] of childData.entries()) {
            console.log(`${key}: ${value}`);
        }

        try {
            const response = await AxiosInstance.post('/video-content', childData, {
                onUploadProgress: (progressEvent) => {
                    const percentCompleted = Math.round(
                        (progressEvent.loaded * 100) / progressEvent.total
                    );
                    setProgress(percentCompleted);
                },
            });

            if (response.status === 201) {
                console.log("Video Created", response);
            } else {
                console.log("Failed to create video, status:", response);
            }
        } catch (error) {
            console.log("Failed to create video", error);
        }
    };

    const handleTypeChange = (e) => {
        setType(e.target.value);
        if (e.target.value === 'series') {
            setSeriesOption('');
        }
    };


    return (
        <div>

            <div className='w-full flex items-center justify-between gap-x-3'>
                <div className='w-1/2'>
                    <p className='text-white'>Type:</p>
                    <select
                        className='w-full rounded-lg p-2 bg-transparent border border-brand-stroke-color my-2'
                        name='type'
                        id='type'
                        value={type}
                        onChange={handleTypeChange}
                    >
                        <option value='series'>Series</option>
                        <option value='video'>Video</option>
                    </select>

                </div>

                {type === 'series' && (
                    <div className='w-1/2'>
                        <p className='text-white'>Choose Option:</p>
                        <select
                            className='w-full rounded-lg p-2 bg-transparent border border-brand-stroke-color my-2'
                            value={seriesOption}
                            onChange={(e) => setSeriesOption(e.target.value)}
                        >
                            <option value='new'>New</option>
                            <option value='existing'>Existing</option>
                        </select>
                    </div>
                )}
            </div>

            {seriesOption === 'existing' && (
                <div className='w-full'>
                    <p className='text-white'>Video Provider</p>
                    <div className="w-full text-black border border-brand-stroke-color rounded-lg p-2 my-2" id="select">
                        <Select
                            value={selectedSeries}
                            onChange={handleSeriesChange}
                            options={seriesOptions}
                            placeholder="Select Series..."
                        />
                    </div>
                </div>
            )}

            <div>
                <p className='text-white'>Title:</p>
                <input type='text'
                    className='w-[100%] rounded-lg p-2 bg-transparent border border-brand-stroke-color my-2'
                    placeholder='Title'
                    name='title'
                    id='title'
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                />
            </div>

            <div>
                <p className='text-white'>Description</p>
                <input type='text'
                    className='w-[100%] rounded-lg p-2 bg-transparent border border-brand-stroke-color my-2'
                    placeholder='Description'
                    name='description'
                    id='description'
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                />
            </div>

            <div>
                <p className='text-white'>Project Name</p>
                <input type='text'
                    className='w-[100%] rounded-lg p-2 bg-transparent border border-brand-stroke-color my-2'
                    placeholder='Project Name'
                    name='Project Name'
                    id='Project'
                    value={projectName}
                    onChange={(e) => setProjectName(e.target.value)}
                />
            </div>

            <div>
                <p className='text-white'>Trailer</p>
                <input type='text'
                    className='w-[100%] rounded-lg p-2 bg-transparent border border-brand-stroke-color my-2'
                    placeholder='Trailer'
                    name='Trailer'
                    id='trailer'
                    value={trailer}
                    onChange={(e) => setTrailer(e.target.value)}
                />
            </div>

            <div className='flex items-center justify-between gap-x-4'>

                <div className='text-white w-1/2'>
                    <p>Publish Date</p>
                    <div className="p-2">
                        <input
                            type="datetime-local"
                            value={startDate}
                            onChange={(e) => setStartDate(e.target.value)}
                            className="w-full p-2 rounded bg-transparent border border-brand-stroke-color text-white"
                        />
                    </div>
                </div>

                <div className='w-1/2'>
                    <p className='text-white'>Video Provider</p>
                    <div className="w-full text-black border border-brand-stroke-color rounded-lg p-2 my-2" id="select">
                        <Select
                            value={selectedProvider}
                            onChange={handleProviderChange}
                            options={providerOptions}
                            placeholder="Select Provider..."
                        />
                    </div>
                </div>

            </div>

            <div className='flex justify-between bg-transparent border border-brand-stroke-color rounded-lg w-[100%] p-2'>

                <div className='p-4'>
                    <p className='text-lg text-white py-2'>Thumbnail</p>
                    <input
                        className='w-[75%] rounded-lg p-4 bg-transparent border border-brand-red my-2'
                        type='file'
                        id='thumbnailInput'
                        onChange={(e) => {
                            handleFileChange(e);
                        }}
                    />
                </div>

                <div className='p-4'>
                    <p className='text-lg text-white py-2'>Price</p>

                    <div className='flex items-center gap-x-1'>
                        <FaMinus className='cursor-pointer hover:scale-105' onClick={decreasePrice} />
                        <input className='w-[75%] rounded-lg p-4 bg-transparent border border-brand-stroke-color my-2' type='text' id='price' value={price} onChange={(e) => setPrice(e.target.value)}></input>
                        <IoMdAdd className='cursor-pointer hover:scale-105' onClick={increasePrice} />
                    </div>
                </div>

            </div>

            <div className='bg-white rounded-full text-black text-lg py-1 px-4 w-fit font-semibold mx-auto my-4 cursor-pointer hover:scale-105' onClick={handleSubmit}>
                Upload
            </div>
        </div>
    )
}

export default UploadVOD;
